module.exports = __webpack_public_path__ + "static/media/title_bg_10.31f6b2b5.png";